<template>
    <section class="checkout-section">
        <div class="section-header">
            <h2> {{ resources.flyIn.editHeading }}</h2>
        </div>
        <vue-form name="new-address">
            <div class="section-row">
                <div  v-for="element in elements" :key="element.id" class="vue-form-row">
                    <vue-input :element="element"
                    @blur="updateValue(element.id, $event.target.value)"/>
                </div>
            </div>
        </vue-form>
        <footer class="section-footer">
            <button class="btn btn--secondary" @click="cancel" :disabled="showSpinner"> {{ resources.flyIn.cancelCTA }} </button>
            <button class="btn" @click="saveAndUse" :disabled="showSpinner">
                <div :class="['spinner', 'white-spinner', { 'spinner-visible': showSpinner }]">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <template v-if="!showSpinner">
                    {{resources.flyIn.saveAndUseCTA}}
                </template>
            </button>
        </footer>
    </section>
</template>
<script src="./edit-address.js"/>
